import { render } from "./FaqManager.vue?vue&type=template&id=5ce269ef"
import script from "./FaqManager.vue?vue&type=script&lang=js"
export * from "./FaqManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__